<template>
	<div class="country-switcher__wrapper">
		<p v-if="!hideText" class="country-switcher__streaming_in">
			{{ $t('WEBAPP_COUNTRY_SWITCHER_STREAMING_IN') + ' ' }}
		</p>

		<button class="country-switcher__button" @click.prevent="openCountrySwitcherModal">
			{{ countryEmoji }}

			<span class="country-switcher__country_name">
				{{ $t(`WEBAPP_COUNTRY_${webLocale.toUpperCase()}`) }}
			</span>

			<FontAwesomeIcon :icon="faAngleDown" />
		</button>
	</div>
</template>

<script setup lang="ts">
import { ModalHelper } from '@/helpers/vfm/modal-helper';
import { SnowplowContext } from '@/helpers/tracking/providers';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { storeToRefs } from 'pinia';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { defineAsyncComponent } from 'vue';

const CountrySwitcherModal = defineAsyncComponent(
	() => import('@/features/buybox/components/CountrySwitcherModal.vue')
);

const { webLocale, countryEmoji } = storeToRefs(useLanguageStore());

const props = defineProps<{ hideText?: boolean; additionalContexts: SnowplowContext[] }>();

const openCountrySwitcherModal = () => {
	ModalHelper.openModal(CountrySwitcherModal, { closable: true });
	TrackingHelper.trackEvent('userinteraction', { action: 'country_selector_clicked' }, props.additionalContexts);
};
</script>

<style lang="scss" scoped>
@import '~@/styles/variables.scss';

.country-switcher {
	&__wrapper {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		margin-inline-start: auto;
	}

	&__button {
		display: flex;
		height: 32px;
		padding: 8px 16px;
		justify-content: center;
		align-items: center;
		gap: 8px;
		border: 1px solid transparent;
		border-radius: 8px;
		background: #303740;
		color: #c6c8cd;
		font-size: 16px;
		text-overflow: ellipsis;
		overflow: hidden;
		transition: background-color 0.1s linear;
		letter-spacing: 0.24px;
		cursor: pointer;

		&:active {
			background-color: transparent;
		}
	}
}
.country-switcher__streaming_in {
	margin: 0;
	margin-inline-end: 8px;
	color: #6f7d90;
	font-feature-settings: 'clig' off, 'liga' off;
	font-size: 16px;
	letter-spacing: 0.24px;
}

@media (max-width: 1024px) {
	.country-switcher__streaming_in {
		display: none;
	}

	.country-switcher__country_name {
		display: none;
	}
}
</style>
